(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/utils.js');
"use strict";


(function (svs) {
  'use strict';

  svs.tur.start_subscription.utils = {
    getUrlParam(param) {
      const href = location.href;
      const reg = new RegExp("[?&]".concat(param, "=([^&#]*)"), 'i');
      const queryStringParam = reg.exec(href);
      return queryStringParam ? queryStringParam[1] : null;
    },
    clearUrlParam(paramToClear) {
      svs.utils.url.refreshQueryString();
      const {
        [paramToClear]: currentParamToClear
      } = svs.utils.url.queryString;
      if (currentParamToClear) {
        let targetString = '';
        let delim = '?';
        for (const param in svs.utils.url.queryString) {
          if (param !== paramToClear) {
            targetString = "".concat(targetString).concat(delim).concat(param, "=").concat(encodeURIComponent(svs.utils.url.queryString[param]));
            delim = '&';
          }
        }
        window.history.replaceState({}, '', "".concat(window.location.pathname).concat(targetString));
        svs.utils.url.refreshQueryString();
      }
    },
    updateQuerystringWithParamAndValue(param, value) {
      this.clearUrlParam(param);
      svs.utils.url.refreshQueryString();
      let targetPath = svs.utils.url.currentPathEncodedParams();
      targetPath = svs.utils.url.updateQueryStringParameter(targetPath, param, value);
      window.history.replaceState({}, '', targetPath);
    },
    preventDoubleClick(buttonTarget) {
      buttonTarget.setAttribute('disabled', 'disabled');
      setTimeout(() => {
        buttonTarget.removeAttribute('disabled');
      }, 5000); 
    },
    async getSubEntryFromContextOrLocalStorage(context) {
      var _context$entryModel;
      const subscriptionEntry = context === null || context === void 0 || (_context$entryModel = context.entryModel) === null || _context$entryModel === void 0 ? void 0 : _context$entryModel.get('subscriptionEntry');
      if (subscriptionEntry && Object.keys(subscriptionEntry).length > 0) {
        return subscriptionEntry;
      }

      return new Promise(resolve => {
        svs.components.Storage.browser.get('start', 'subscription', subObject => {
          if (subObject !== null && subObject !== void 0 && subObject.entry && Object.keys(subObject.entry).length > 0) {
            resolve(subObject.entry);
          } else {
            svs.components.Storage.browser.get('change', 'subscription', subObject => {
              resolve(subObject !== null && subObject !== void 0 && subObject.entry && Object.keys(subObject.entry).length > 0 ? subObject.entry : null);
            });
          }
        });
      });
    },
    afterSubPayRedirectUrl(subEntry, subscriptionId) {
      var _subEntry$wagers;
      let isChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      const subFirstBet = subEntry === null || subEntry === void 0 || (_subEntry$wagers = subEntry.wagers) === null || _subEntry$wagers === void 0 || (_subEntry$wagers = _subEntry$wagers[0]) === null || _subEntry$wagers === void 0 || (_subEntry$wagers = _subEntry$wagers.bets) === null || _subEntry$wagers === void 0 ? void 0 : _subEntry$wagers[0];
      const isLyckoplatsen = (subFirstBet === null || subFirstBet === void 0 ? void 0 : subFirstBet.productId) === 'GEO1';
      let isLyckoplatsenAndAskForCharity = false;
      if (isLyckoplatsen) {
        var _subFirstBet$geoBoard;
        const charityId = subFirstBet === null || subFirstBet === void 0 || (_subFirstBet$geoBoard = subFirstBet.geoBoardData) === null || _subFirstBet$geoBoard === void 0 ? void 0 : _subFirstBet$geoBoard.charityId;
        isLyckoplatsenAndAskForCharity = charityId !== undefined && charityId <= 0;
      }
      if (isLyckoplatsenAndAskForCharity) {
        const subDetailUrl = "".concat(svs.core.urlMapping.get('lyckoplatsen_OngoingBets_Subscription'), "/").concat(subscriptionId);
        return "".concat(subDetailUrl, "?").concat(isChange ? 'changeSub' : 'newSub', "=1#charity"); 
      }
      return "".concat(svs.core.urlMapping.get('myGamingsSubscriptions'), "?").concat(isChange ? 'changeSubscription' : 'subscriptionId', "=").concat("00000000".concat(subscriptionId).slice(-8));
    }
  };
})(svs, jQuery);

 })(window);